/**
 * Lookbook Image Interactions
 * Handles image hover effects and interactions for the lookbook section
 */

(function() {
    // Initialize when DOM is fully loaded
    document.addEventListener('DOMContentLoaded', initLookbook);
    
    function initLookbook() {
      const lookbookContainer = document.querySelector('[data-lookbook-container]');
      if (!lookbookContainer) return;
      
      // Initialize click-to-enlarge lightbox
      initLightbox();
      
      // Re-initialize when Shopify section is reloaded (e.g. images added/reordered in the editor)
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
          if (event.detail.sectionId.includes('lookbook')) {
            initLightbox();
          }
        });
      }
    }
    
    // Add support for lightbox functionality
    function initLightbox() {
      const lookbookTiles = document.querySelectorAll('.lookbook-tile');
      
      lookbookTiles.forEach(tile => {
        tile.addEventListener('click', function(event) {
          // If the click is on a link or a shoppable pin, let those handle the click instead
          if (event.target.closest('a')) return;
          if (event.target.closest('.lookbook-pin')) return;
          
          const image = tile.querySelector('img');
          if (!image) return;
          
          // Create lightbox
          const lightbox = document.createElement('div');
          lightbox.className = 'lookbook-lightbox';
          lightbox.style.position = 'fixed';
          lightbox.style.top = '0';
          lightbox.style.left = '0';
          lightbox.style.width = '100%';
          lightbox.style.height = '100%';
          lightbox.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
          lightbox.style.zIndex = '9998'; /* stays below the shared pin popup (z-index 9999) */
          lightbox.style.display = 'flex';
          lightbox.style.alignItems = 'center';
          lightbox.style.justifyContent = 'center';
          
          // Wrapper shrink-wraps to the rendered image size, so cloned pins
          // (positioned by percentage via .lookbook-pins { inset: 0 }) line up correctly
          const imageWrap = document.createElement('div');
          imageWrap.style.position = 'relative';
          imageWrap.style.display = 'inline-block';
          imageWrap.style.maxWidth = '90%';
          imageWrap.style.maxHeight = '90%';
          
          // Create the lightbox image
          const lightboxImg = document.createElement('img');
          lightboxImg.src = image.src;
          lightboxImg.style.display = 'block';
          lightboxImg.style.maxWidth = '100%';
          lightboxImg.style.maxHeight = '90vh';
          lightboxImg.style.objectFit = 'contain';
          
          imageWrap.appendChild(lightboxImg);
          
          // Clone any shoppable pins from this tile onto the enlarged image
          const pinsLayer = tile.querySelector('.lookbook-pins');
          if (pinsLayer && pinsLayer.children.length > 0) {
            imageWrap.appendChild(pinsLayer.cloneNode(true));
          }
          
          // Add close functionality — but ignore clicks on a shoppable pin,
          // so tapping a pin shows its popup instead of closing the lightbox
          lightbox.addEventListener('click', function(event) {
            if (event.target.closest('.lookbook-pin')) return;
            document.body.removeChild(lightbox);
          });
          
          // Add to DOM
          lightbox.appendChild(imageWrap);
          document.body.appendChild(lightbox);
        });
      });
    }
  })();